import { Link } from "react-router-dom";

const CTA = ({ question, page, linkText }) => {
  return (
    <p className="text-center text-sm text-ink-500">
      {question}{" "}
      <Link
        to={`/${page}`}
        className="font-semibold leading-6 text-accent-600 hover:text-accent-500"
      >
        {linkText}
      </Link>
    </p>
  );
};

export default CTA;
